import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { IUser } from "../interface/user";
import { GenericLayerService } from "../services/generic-layer.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { WeatherForecastService } from "src/app/services/weather-forecast.service";
import { Globals } from "../shared/globals";
import { QueryLayersService } from "../services/query-layers.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { EsriMapComponent } from "src/app/esri-map/esri-map.component";
import { AssetDetailService } from "src/app/services/asset-detail.service";
import { EventEmittersService } from "../services/event-emitters.service";
import { QueryBuilderService } from "../services/query-builder.service";
import { UserService } from "src/app/services/user.service";
import { AssetAttributesService } from "../services/asset-attributes.service"; // Added by Abhilash for JIRA ID:-65 on 08/21/2021
import { faCalendarAlt as faCalendar, faSave } from "@fortawesome/free-regular-svg-icons";
import { faInfoCircle, faLock, faWrench, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { DropdownComponent } from "../shared/dropdown/dropdown.component";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgIf, NgClass, NgFor, DatePipe } from "@angular/common";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { FormsModule } from "@angular/forms";
import { IDropdownListItem } from "../interface/DropDownListItem";
import { IRelationshipInfo } from "../interface/relationshipInfo"; 

@Component({
    selector: "sms-create-task",
    templateUrl: "./create-task.component.html",
    styleUrls: ["./create-task.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FormsModule, CdkDrag, ConfigurableHeaderComponent, CdkDragHandle, NgIf, MatFormFieldModule,
            NgClass, MatInputModule, MatDatepickerModule, MatButtonModule, MatSelectModule, MatOptionModule,
            NgFor, DropdownComponent, TranslateModule, CustomTranslatePipe, DatePipe]
})
export class CreateTaskComponent implements OnInit {
  getFilteredFeaturesByFieldSubscribe: Subscription;
  getFilteredFeaturesByTwoFieldSubscribe: Subscription;

  //10/15/26 seem not used so commented out
  // getUserLayerAccessSubscribe: Subscription;   
  // public modalReference: NgbModalRef;
  // getUserListSubscribe: Subscription;

  constructor(
    private modalService: NgbModal,
    private assetAttributesService: AssetAttributesService, // Added by Abhilash for JIRA ID:-65 on 08/21/2021
    private authenticationService: AuthenticationService,
    public objGlobals: Globals,
    private genericLayerService: GenericLayerService,
    private weatherService: WeatherForecastService,
    private translateService: TranslateService,
    private queryLayersService: QueryLayersService,
    private esrimap: EsriMapComponent,
    public assetDetailService: AssetDetailService,
    private eeService: EventEmittersService,
    //private queryb: QueryBuilderService,    // seems not used to commented out
    private userService: UserService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.userRoles = this.objGlobals.userRoles;
  }

  @Input() asset: any;            //asst to create a task for. must be null if editing an existing task.
  @Input() taskAttributes: any;   //attributes of existing task to edit. null/ignored if asset is provided.
  @Input() LayerName: any;        //not used?
  @Input() FeatureLayer: any;     //used to new up FeatureLayer objects
  @Input() Graphic: any;          //used to new up Graphic objects
  @Input() webMercatorUtils: any; //used to work with asset geometry
  @Input() delete: boolean;       //not used?
  @Input() editCreateTaskForm;    //attributes on this object used to enable/disable sms-create-task inputs -- set Edit or Read Only mode

  @Output() showTasks = new EventEmitter();       //close form
  @Output() maintenanceId = new EventEmitter();
  @Output() closeCard = new EventEmitter();
  @Output() taskDeleted = new EventEmitter();     //not listend to

  currentUser: IUser;
  isEdit = "false";
  private existingTask = true;   // if so, form is set up to edit it. if not, form is set up to create a new task. Edge case is when task is closed and form is set up read only - this only happens when MyTasks Completed Tasks table record is clicked.
  public showResources: boolean = false;

  // feature layers referenced to load dropdowns
  private maintenanceFL: any;  
  private activityFL: any;
  private activityToolkitFL: any;

  public workerList: IDropdownListItem[] = [];
  public reasonList: IDropdownListItem[] = [];
  public activityList: IDropdownListItem[] = [];
  
  public activityToolKitList: any[] = [];
  private activityCodedValues: any[] = [];

  // set but not used
  private activityToolkitDomines: any[];

  // initial values for dropdowns
  worker: string;
  reason: string;
  activity: string;

  // user configured defaults
  defComments;
  defDesc;
  defReason;
  defWorker;
  defWorkOrder;


  requiredStatus: any = {}; // Added by Abhilash for JIRA ID:-65 on 08/21/2021
  hasAdvancedFields = false;


  private assetRelationships: IRelationshipInfo[] = [];

  dateToday;
  startTime;
  endTime;
  taskNameval;
 //////// layerDomines;
  layerName;            // aka AssetName (e.g. Sign, Support, Guardrail) - a property of Maintenance table
  public createdBy: string = "";
  workorderID;
  wrkType;
  wrkStatus;
  priority;
  region;
  faSave = faSave;
  faLock = faLock;
  faUnlock = faUnlock;
  faInfoCircle = faInfoCircle;
  faWrench = faWrench;
  faCalendar = faCalendar;
  regions; //7/28/20 jcc - need all regions to build out workers list
  location;
  duration;
  desc;
  comments;
  geometry;
  scheduled: any;
  detailForecastData;
  showTable;
  private activitySubtypeId: number;   // activity subtypeId of active asset. This is saved with each Activity record, in 'Asset' field, but I'm not sure its ever used or if asset LayerId was the value inteded to go there. It is done this same way in other components.
  disableActivity: boolean = false;
  disableReason: boolean = false;
  statusCodes;
  WorkOrderTypeCodes;
  dhours;
  dminutes;
  todayDate; //= new Date();
  public createdDate: any = "";
  userList1 = [];
  public disableWeatherIcon = false;
  disabledSave = false;
  LayerListByUser;
  userIsDataEditor = false;
  public taskInfo;
  userRoles;
  activeAsset;
  activityName;

  public assetId: string = "";
  private assetLayerId: number = -1;

  ngOnInit() {
    this.activeAsset = this.asset ? this.asset : this.eeService.activeAssetInfo; // lock in asset info (in case user clicks other map pin or navigates asset viewer while create-task is open. todo just make it modal??)
    this.assetId = this.activeAsset[0].AssetID;
    this.assetLayerId = this.activeAsset[1].lyrObj.layerId;
    this.assetRelationships = this.activeAsset[1].lyrObj.relationships.filter( (r:any) => r.name.includes("ToSign") || r.name.includes("ToLight"));   

    //UI setup
    this.assetAttributesService.getMaintenanceConfig().subscribe((res: any) => {
      res.features?.forEach( (f) => {
        this.requiredStatus[f.attributes.Field] = f.attributes.IsRequired ? true : false;
      });
    });
    this.hasAdvancedFields = this.currentUser.clientType === "PROFESSIONAL" ? true : false;
    this.userIsDataEditor = this.userService.isDataEditorForRoleRegionAndLayer(this.currentUser, this.assetLayerId);   //this.IsDataEditorForRoleRegionAndLayer();
    this.createdBy = this.currentUser.displayName;

    //user defined defaults
    const woDefaultsJSON: any = localStorage.getItem("workOrderDefaults");
    if (woDefaultsJSON) {
      const woDefaults = JSON.parse(woDefaultsJSON);
      this.defWorkOrder = this.workorderID = woDefaults.WorkOrder;
      this.defWorker = this.worker = woDefaults.Worker;
      this.defReason = this.reason = woDefaults.Reason;
      this.defComments = this.comments = woDefaults.Comments;
      this.defDesc = this.desc = woDefaults.Description;
    }

    // default form field enabled states (overridden if editCreateTaskForm is passed in)
    if (!this.editCreateTaskForm) {
      this.editCreateTaskForm = {
        workorderID: true,
        wrkType: true,
        wrkStatus: false,
        createdBy: false,
        dateToday: false,
        priority: true,
        region: false,
        worker: true,
        location: false,
        reason: true,
        activity: true,
        duration: false,
        sheduledTime: true,
        startTime: false,
        endTime: false,
        assetId: false,
        desc: true,
        comments: true
      };
    }
    ////*** end general UI setup

    this.maintenanceFL = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
    this.activityFL = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    this.activityToolkitFL = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityToolkitId, { outFields: ["*"] });
    this.activityName = this.objGlobals.userSelectedActivity  // not better to make an @Input to get this directly?
                                             
    if (this.asset) {  // Create Task
      // default values
      this.priority = 0;
      this.duration = "60";
      this.dminutes = this.duration % 60;
      this.dhours = (this.duration - this.dminutes) / 60;
      this.layerName = this.asset[1].name;
      if (this.asset[0].Region4) {
        this.region = this.asset[0].Region4;
      } else if (this.asset[0].Region3) {
        this.region = this.asset[0].Region3;
      } else if (this.asset[0].Region2) {
        this.region = this.asset[0].Region2;
      } else if (this.asset[4].region) {
        this.region = this.asset[4].region;
      }
      this.asset.forEach((el) => {    //7/28/20 jcc attach all regions to asset
        if (el.regions) {
          this.regions = el.regions;
        }
      });
      this.editCreateTaskForm.activity = true;
      this.disableActivity = false;
      this.existingTask = false;

    } else if (this.taskAttributes) {   // Edit Task
      this.regions = {
        region1: this.taskAttributes.Region1,
        region2: this.taskAttributes.Region2,
        region3: this.taskAttributes.Region3,
        region4: this.taskAttributes.Region4
      };
      this.workorderID = this.taskAttributes.WorkOrder;
      this.wrkType = this.taskAttributes.WorkOrderType;
      this.wrkStatus = this.taskAttributes.Status;
      this.createdBy = this.taskAttributes.CreatedBy;
      this.dateToday = new Date(this.taskAttributes.CreationDate).toLocaleDateString();
      this.priority = parseInt(this.taskAttributes.Priority, 10);
      this.region = this.taskAttributes.Region;
      this.worker = this.taskAttributes.Worker;
      this.location = this.taskAttributes.Location;
      this.reason = this.taskAttributes.Reason;
      this.activity = this.taskAttributes.Activity;
      this.duration = this.taskAttributes.EstimatedDuration;
      this.dminutes = this.duration % 60;
      this.dhours = (this.duration - this.dminutes) / 60;
      this.scheduled = this.taskAttributes.SheduledDate ? new Date(this.taskAttributes.SheduledDate) : null;
      this.createdDate = this.taskAttributes.CreationDate ? new Date(this.taskAttributes.CreationDate) : null;
//      this.todayDate = this.taskAttributes.StartTime ? new Date(this.taskAttributes.StartTime) : null;
      this.startTime = this.taskAttributes.StartTime ? new Date(this.taskAttributes.StartTime) : null;
      this.endTime = this.taskAttributes.EndTime ? new Date(this.taskAttributes.EndTime) : null;
      this.desc = this.taskAttributes.WorkOrderDesc;
      this.comments = this.taskAttributes.Comment;
      this.layerName = this.taskAttributes.AssetName;
      this.geometry = this.objGlobals.taskGeometry;   //TODO*** calculate internally, don't want to rely on globals

      this.editCreateTaskForm.activity = false;  // ensure Activity can never be changed on an existing task
      this.disableActivity = true;
      this.existingTask = true;

      if (this.taskAttributes.Status === "Closed") {  // special case
        // closed task are read only
        this.editCreateTaskForm = {
          workorderID: false,
          wrkType: false,
          wrkStatus: false,
          createdBy: false,
          dateToday: false,
          priority: false,
          region: false,
          worker: false,
          location: false,
          reason: false,
          activity: false,
          duration: false,
          sheduledTime: false,
          startTime: false,
          endTime: false,
          assetId: false,
          desc: false,
          comments: false
        };
        this.disabledSave = true;
        this.startTime = "";
      }

      if (!this.activity) {  //10/15/26 seems Activity is attached to the existingTask prior to sending it to this component. getActivity() here may be obsolete.
        this.getActivity(this.taskAttributes.MaintID);
      } 
      this.getWeatherInformation();
    }

    this.userService.getWorkerList(this.currentUser.clientId, [this.assetLayerId]).subscribe(
      (result: any) => {
        this.workerList = result.map((data) => ({ value: data.displayName, display: data.displayName }));  //username or both should be displayName?
      },
      (error: any) => {this.workerList = [{ value: this.currentUser.displayName, display: this.currentUser.displayName }]}
    );

    const date = new Date();
    this.dateToday = date.toLocaleDateString();

    this.activityFL.on("Load", (evt) => {
      this.getActivityList(evt.layer.types, this.layerName);
    });

    this.activityToolkitFL.on("Load",  (evt) => {
      this.activityToolkitDomines = evt.types;
    });

    this.maintenanceFL.on("Load", (evt) => {
      this.statusCodes = evt.layer.fields.find((f) => f.name==="Status")?.domain.codedValues;
      this.reasonList = evt.layer.fields.find((f) => f.name==="Reason")?.domain.codedValues.map(cv => ({ value: cv.name, display: cv.name }));
      this.reason = this.reason ?? this.reasonList[0].value;
      this.WorkOrderTypeCodes = evt.layer.fields.find((f) => f.name==="WorkOrderType")?.domain.codedValues;
      this.wrkType = this.wrkType ?? this.WorkOrderTypeCodes[0].code;
    });

  }
  ngOnDestroy(): void {
    console.log("destroy");
  }
  toggleResources() {
    this.showResources = !this.showResources;
  }
  close() {
    this.showTasks.emit(false);
  }

  private getActivityList(activitySubtypes: any[], layerName: string) {
    // activity table has subtypes for each potential asset class. That way each asset class can have its own set of activities.
    try {
      this.activityList = [];
      const activitySubtype = activitySubtypes.find( (l) => { return l.name === layerName });
      this.activitySubtypeId = activitySubtype?.id;  // this will not change (until next time create task form is opened). It is the activity subtype for the active asset.
      this.activityCodedValues = activitySubtype?.domains.Activity.codedValues;
      const userSelectableActivities = this.activityCodedValues.filter( (item) => {
        return ["New", "Replace", "Relocate", "Retire", "DetailUpdate", "Collect", "Reshape"].indexOf(item.code) === -1;
      });
      switch (this.activityName) {
        case "General":
          this.activityList = userSelectableActivities.map( (item) => { return {value: item.code, display: item.name}; }); // map to IDropdownListItem structure
          this.activity = this.activity ?? userSelectableActivities[0].code;
          break;
        default:  // RSAM JIRA ID: 963 Bug
          this.activityList = this.activityCodedValues.filter( (cv) => { return cv.code === this.activityName; }).map( (cv) => { return {value: cv.code, display: cv.name}; });
          this.activity = this.activity ?? this.activityName;  // Retire or Replace
          break;
      }
      this.activityChange(this.activity);
    } catch (error) {
      console.error(error);
    }
  }

  // Added by Abhilash for JIRA ID:-65 on 08/21/2021

  private validateTaskForm(): boolean {
    let valid:boolean = true;
    const allFields = Object.keys(this.requiredStatus);
    allFields.forEach((element) => {
      if (this.requiredStatus[element]) {
        // only validate fields that a user can modify on create/edit task form
        switch (element) {
          case "SheduledDate": {
            if ((!this.scheduled || !this.scheduled.getTime()) && this.hasAdvancedFields) {
              valid = false;
              this.scheduled = null;  //reset model so required styling will be applied to input field if user changed then deleted value.
            }
            break;
          }
          case "StartTime": {
            if (!this.todayDate && this.hasAdvancedFields) {
              valid = false;
              this.startTime = null;
            }
            break;
          }
          case "Priority": {
            if (!this.priority && this.priority !== 0 && this.hasAdvancedFields) {
              valid = false;
              this.priority = null;
            }
            break;
          }
          case "WorkOrder": {
            if (!this.workorderID) {
              valid = false;
              this.workorderID = null;
            }
            break;
          }
          case "Worker": {
            if (!this.worker) {
              valid = false;
              this.worker = null;
            }
            break;
          }
          case "Reason": {
            if (!this.reason) {
              valid = false;
              this.reason = null;
            }
            break;
          }
          case "Activity": {
            if (!this.activity) {
              valid = false;
              this.activity = null;
            }
            break;
          }
          case "WorkOrderDesc": {
            if (!this.desc) {
              valid = false;
              this.desc = null;
            }
            break;
          }
          case "Comment": {
            if (!this.comments) {
              valid = false;
              this.comments = null;
            }
            break;
          }
        }
      }
    });
    return valid;
  }

  public saveTaskForLater(): void {
    let complete:boolean = false;
    try {
      if (!this.validateTaskForm()) {
        Swal.fire(this.translateService.instant("Select.createtask.ValidationMessage"));
      } else {
        this.disabledSave = true;
        this.duration = this.dhours * 60 + this.dminutes;
        const featurese = [];
        const features = new this.Graphic();

        if (this.existingTask) {

          // update maintenance record
          features.setAttributes(this.collectTaskAttributes(this.existingTask, complete));
          featurese.push(features);
          this.maintenanceFL
            .applyEdits(null, featurese, null)
            .then( () => {
                this.taskDeleted.emit(true);  // should this not be false? why even emit taskDeleted?
                this.assetDetailService.tasksModified.emit(true);
                this.eeService.emitTaskCreated.emit(true);  // should this not be false? why even emit TaskCreated?
              },
              this.showUpdateMesage()
            )
            .catch((error: any) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
              console.log("error = ", error);
            });
        }

        //create new task
        else {

          // insert Maintenance record
          features.setAttributes(this.collectTaskAttributes(this.existingTask, complete));
          featurese.push(features);
          this.maintenanceFL.applyEdits(featurese, null, null).then( (newrow: any) => {

            //update MaintID
            const featureseAssetID: any[] = [];
            const featuresA = new this.Graphic();
            featuresA.setAttributes({
              OBJECTID: newrow[0].objectId,
              MaintID: "MNT_" + newrow[0].objectId
            });
            const maintenanceRelId = "MNT_" + newrow[0].objectId;
            featureseAssetID.push(featuresA);
            this.maintenanceFL.applyEdits(null, featureseAssetID, null).then( (newrow: any) => {

              //insert Activity record
              const activityFeaturese = [];
              const activityFeatures = new this.Graphic();
              activityFeatures.setAttributes({
                MaintID: maintenanceRelId,
                Asset: this.activitySubtypeId,
                Activity: this.activity,
                Description: this.desc,
                ModifiedBy: this.createdBy,
                LastModifyDate: new Date(Date.now()).getTime()
              });
              activityFeaturese.push(activityFeatures);
              this.activityFL.applyEdits(activityFeaturese, null, null).then( () => {

                // see if task is related to a complaint/crowdsourced issue
                if (  this.objGlobals.complaintID != null 
                      && this.objGlobals.complaintID !== undefined 
                      && this.objGlobals.complaintID !== ""
                    ){
                  this.objGlobals.longitude = this.asset[0].Longitude;
                  this.objGlobals.latitude = this.asset[0].Latitude;
                  this.objGlobals.assetID = this.asset[0].AssetID;
                  this.esrimap.crowdsource();
                }

                this.assetDetailService.tasksModified.emit(true);
                this.eeService.emitTaskCreated.emit(true);
                this.showCreateMesage();
              })
              .catch(
                (error: any) => {
                  console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                  console.log("error = ", error);
                  this.maintenanceFL.applyEdits(null, null, featureseAssetID);  // rollback new maintenance record??
                }
              );

            })
            .catch( (error: any) => {
                console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                console.log("error = ", error);
                this.maintenanceFL.applyEdits(null, null, featureseAssetID);
            });

          }
          )
          .catch((error: any) => {
            console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
            console.log("error = ", error);
          });

        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  saveAndCompleteTask() {
    try {
      let complete:boolean = true;

      if (!this.validateTaskForm()) {
        Swal.fire(this.translateService.instant("Select.createtask.ValidationMessage"));
      } else {

        //todo*** test this section when coming from task table and MakeView
        if (this.esrimap.taskTableVisible){
          // jcc 071525 need to collect asset data here if createtask form was opened from my-task table?? form should init and already populate correctly
          this.activeAsset = this.eeService.activeAssetInfo;
          this.assetRelationships = this.objGlobals.relatedAssetInfo; // safe to reference globals here -- my task version of asset viewer is one location at a time.
        }

        this.disabledSave = true;
        this.duration = this.dhours * 60 + this.dminutes;
        const featurese = [];
        const features = new this.Graphic();
        let geomString;
        let assetId;
        this.wrkStatus = "Closed";


        if (this.existingTask) {     
          
          // Update existing maintenance record
          features.setAttributes(this.collectTaskAttributes(this.existingTask, complete));
          featurese.push(features);
          this.maintenanceFL
            .applyEdits(null, featurese, null)
            .then( () => {
                this.assetDetailService.Query = this.esrimap.Query;
                this.assetDetailService.QueryTask = this.esrimap.QueryTask;
                this.esrimap.map.getLayer("sms-layers").refresh();

                if (this.activity === "New") {
                  // update asset's InstallDate
                  this.genericLayerService.getFilteredFeaturesByField(this.assetLayerId, "AssetID", this.assetId).subscribe((resultObj: any) => {
                    const features = new this.Graphic();
                    const att: any = [];
                    att.OBJECTID = resultObj.features[0].attributes.OBJECTID;
                    att.InstallDate = new Date(Date.now()).getTime();
                    att.ModifiedBy = this.currentUser.username;
                    att.LastModifyDate = new Date(Date.now()).getTime();
                    features.setAttributes(att);
                    this.queryLayersService.updateAsset(this.activeAsset[1].lyrObj, features)
                      .then((result) => {
                        this.eeService.emitTaskCompleted.emit(true);  // not done consistently. what about for Replace, Retire, and other activities?
                      });
                  });
                }

                else if (this.activity === "Replace") {
                  const activityLayerUrl = this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId; //ReplaceTask method doesn't use this now
                  this.assetDetailService.Query = this.esrimap.Query;
                  this.assetDetailService.QueryTask = this.esrimap.QueryTask;
                  this.assetDetailService.ReplaceTask(this.activeAsset, this.maintenanceFL, activityLayerUrl, this.FeatureLayer, this.Graphic, this.currentUser, features.attributes);
                  this.esrimap.map.getLayer("sms-layers").refresh();
                }

                else if (this.activity === "Retire") {
                  this.assetDetailService.Query = this.esrimap.Query;
                  this.assetDetailService.QueryTask = this.esrimap.QueryTask;
                  this.assetDetailService.RetireAsset(this.activeAsset, this.maintenanceFL, this.currentUser, this.FeatureLayer, this.assetRelationships);    // jcc TSDRSAM-3105
                  this.closeCard.emit(true);

                  if (this.layerName == "Sign" || this.layerName == "Light") {
                    setTimeout(() => {
                      this.eeService.setchildDeleted(false);
                    },5000)
                  } else {
                    if (this.esrimap.map.getLayer("sms-selection")) {
                      this.esrimap.map.getLayer("sms-selection").remove(
                        this.esrimap.map.getLayer("sms-selection").graphics.filter((item) => {
                          //if (item.attributes.AssetID == this.eeService.activeAssetInfo[0].AssetID) return item;
                          if (item.attributes.AssetID == this.assetId) return item;
                        })[0]
                      );

                      this.esrimap.map.getLayer("sms-selection").refresh();
                      this.esrimap.map.graphics.clear();
                    }

                    this.removeActiveAssetFromSelectedSet();
                    this.esrimap.map.getLayer("sms-selection").refresh();
                  }

                  this.esrimap.map.graphics.clear();
                  this.esrimap.map.getLayer("sms-layers").refresh();
                  this.assetDetailService.tasksModified.emit(true);
                }

                else {  
                  this.assetDetailService.tasksModified.emit(true);
                }

                this.eeService.emitTaskAdded(true);
                this.assetDetailService.tasksModified.emit(true);    // don't like calling this directly
                this.eeService.emitTaskCreated.emit(true);           // don't like calling this directly

              },
              this.showUpdateMesage(),
              this.maintenanceId.emit(true)
            )
            .catch( (error:any) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
              console.log("error = ", error);
            });
        }
        
        else {  // new task

          // insert maintenance record
          features.setAttributes(this.collectTaskAttributes(this.existingTask, complete));
          featurese.push(features);
          this.maintenanceFL.applyEdits(featurese, null, null)
            .then( (newrow) => {

              // update MaintID on new Maintenance record
              const featureseAssetID = [];
              const featuresA = new this.Graphic();
              featuresA.setAttributes({ OBJECTID: newrow[0].objectId, MaintID: "MNT_" + newrow[0].objectId });
              featureseAssetID.push(featuresA);
              this.maintenanceFL.applyEdits(null, featureseAssetID, null)
                .then( () => {
                  this.showCreateMesage();
                })
                .catch( (error) => {
                    console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                    console.log("error = ", error);
                    this.maintenanceFL.applyEdits(null, null, featureseAssetID);
                });

              // insert Activity record
              const actfeaturese = [];
              const actfeatures = new this.Graphic();
              actfeatures.setAttributes({
                MaintID: "MNT_" + newrow[0].objectId,
                Asset: this.activitySubtypeId,
                Activity: this.activity,
                Description: this.activity,
                ModifiedBy: this.createdBy,
                LastModifyDate: new Date(Date.now()).getTime()
              });
              actfeaturese.push(actfeatures);
              this.activityFL.applyEdits(actfeaturese, null, null).then( () => {
                this.showCreateMesage();
                if (!(this.activity === "Replace" || this.activity === "Replace")) {  //TODO*** wtf
                  this.assetDetailService.tasksModified.emit(true);
                  this.eeService.emitTaskCreated.emit(true);  // 10/16/26 as of now listener for this and emitTaskCompleted do the same thing. don't want to do that thing twice
                }
              })
              .catch( (error) => {
                console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                console.log("error = ", error);
                this.maintenanceFL.applyEdits(null, null, featureseAssetID);
              });
                
              if (this.activity === "Replace") {
                const activityLayer = this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId;
                this.assetDetailService.Query = this.esrimap.Query;
                this.assetDetailService.QueryTask = this.esrimap.QueryTask;
                this.assetDetailService.ReplaceTask(this.activeAsset, this.maintenanceFL, activityLayer, this.FeatureLayer, this.Graphic, this.currentUser, features.attributes);
                this.esrimap.map.getLayer("sms-layers").refresh();
                this.assetDetailService.tasksModified.emit(true);
                this.closeCard.emit(true);
              }
              else if (this.activity === "Retire") {
                this.assetDetailService.Query = this.esrimap.Query;
                this.assetDetailService.QueryTask = this.esrimap.QueryTask;
                this.assetDetailService.RetireAsset(this.activeAsset, this.maintenanceFL, this.currentUser,this.FeatureLayer, this.assetRelationships);    // jcc TSDRSAM-3105
                this.closeCard.emit(true);

                if (this.layerName == "Sign" || this.layerName == "Light") {
                  setTimeout(() => {
                    this.eeService.setchildDeleted(false);
                  }, 2000);
                } else {
                  if (this.esrimap.map.getLayer("sms-selection")) {
                    if (this.esrimap.map.getLayer("sms-selection"))
                      this.esrimap.map.getLayer("sms-selection").remove(
                        this.esrimap.map.getLayer("sms-selection").graphics.filter((item) => {
                          if (item.attributes.AssetID == this.assetId) return item;
                        })[0]
                      );

                    this.esrimap.map.getLayer("sms-selection").refresh();
                    //if (this.map) this.map.graphics.clear();
                  }

                  this.removeActiveAssetFromSelectedSet();
                  this.esrimap.map.getLayer("sms-selection").refresh();
                }

                this.esrimap.map.getLayer("sms-layers").refresh();
                this.assetDetailService.tasksModified.emit(true);
              }
              else {  //(this.activity !== "Retire" && this.activity !== "Replace") {
                this.assetDetailService.tasksModified.emit(true);
              }

            },

            this.maintenanceId.emit(true)
          )
          .catch((error:any) => {
            console.log("===============================================");
            console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
            console.log("error = ", error);
          });

        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  private removeActiveAssetFromSelectedSet(){
      if (this.eeService.selectedSet?.length > 0) {

        // remove asset from selectedSet
        this.eeService.selectedSet[this.eeService.selectedLayerIndex].Data.splice(this.eeService.selectedFeatureIndex, 1);
        this.eeService.setAssetViewer(false); // close the existing so stale data doesn't continue to show in details panel

        // reset map and asset viewer
        if (this.eeService.selectedSet[this.eeService.selectedLayerIndex].Data.length > 0) {
          this.eeService.setSelectedFeaturesOnMap(this.eeService.selectedSet, this.eeService.selectedLayerIndex, 0);
          this.eeService.setAssetViewer(true);
        } else {
          this.eeService.setSelectedFeaturesOnMap(this.eeService.selectedSet);
        }
      }
  }

  collectTaskAttributes(update:boolean, complete:boolean){
    type TaskAttributes = { [key: string] : any; };

    // form data
    const attributes: TaskAttributes = {
      Activity: this.activity,
      Comment: this.comments,
      EstimatedDuration: parseInt(this.duration, 10),
      LastModifyDate: new Date(Date.now()).getTime(),
      ModifiedBy: this.currentUser.username,
      Priority: parseInt(this.priority, 10),
      Reason: this.reason,
      Region: this.region,
      SheduledDate: this.scheduled ? this.scheduled.getTime() : null,
      StartTime: this.startTime ? new Date(this.startTime).getTime() : null,
      Status: this.wrkStatus,
      Worker: this.worker,
      WorkOrder: this.workorderID,
      WorkOrderDesc: this.desc,
      WorkOrderType: this.wrkType,  // what is this?
    }

    if (update) {
      attributes.OBJECTID = this.taskAttributes.OBJECTID;  // used by ArcGIS api to determine which record to update
    }
    else {   //new

      let geomString = (this.asset && this.asset[3].geometry != null) ? this.asset[3].geometry.toJson() : null;
      if (geomString?.paths){  // line feature
        geomString.x = geomString.paths[0][0][0];
        geomString.y = geomString.paths[0][0][1];
      }

      attributes.AssetID = this.asset ? this.asset[0].AssetID : this.taskAttributes.AssetID;  // todo get rid of ambiguity if it still exists;
      attributes.AssetName = this.layerName;   // (this.asset && this.asset[1]) ? this.asset[1].layerName : "";
      attributes.CreatedBy = this.currentUser.username;
      attributes.CreationDate = new Date(Date.now()).getTime();
      attributes.GeomWKT = JSON.stringify(geomString);
    }

    if (complete){
      attributes.CompletedBy = this.currentUser.username;
      attributes.CompletionDate = new Date(Date.now()).getTime();
      attributes.EndTime = new Date().getTime();
    }
    return attributes;
  }

  startTask() {
    this.startTime = new Date(Date.now()).getTime();
  }

  showCreateMesage() {
    try {
      if (this.activityToolKitList && this.activityToolKitList.length === 1) {
        const toolname = this.activityToolKitList[0].attributes.ToolName;

        if (toolname !== "Standard Resources") {
          Swal.fire(this.translateService.instant("Select.createtask.taskcreate"));
          this.showTasks.emit(false);
        } else {
          Swal.fire(this.translateService.instant("Select.createtask.tasksuccesswithstandardresource"));
          this.showTasks.emit(false);
        }
      } else {
        Swal.fire(this.translateService.instant("Select.createtask.taskcreate"));
        this.showTasks.emit(false);
      }
    } catch (error) {
      console.error(error);
    }
  }
  showUpdateMesage() {
    Swal.fire(this.translateService.instant("Select.createtask.taskupdate"));
    this.showTasks.emit(false);
  }

  daysBetween(first, second) {
    try {
      // Copy date parts of the timestamps, discarding the time parts.
      const one = new Date(first.getFullYear(), first.getMonth(), first.getDate());
      const two = new Date(second.getFullYear(), second.getMonth(), second.getDate());
      // Do the math.
      const millisecondsPerDay = 1000 * 60 * 60 * 24;
      const millisBetween = two.getTime() - one.getTime();
      const days = millisBetween / millisecondsPerDay;
      // Round down.
      return Math.floor(days);
    } catch (error) {
      console.error(error);
    }
  }
  showDetailTable() {
    try {
      if (this.daysBetween(new Date(), this.scheduled) > 5) {
        this.disableWeatherIcon = true;
        this.showTable = false;
        const icondiv = document.getElementById("weatherIconDiv");
        icondiv.setAttribute("class", "");
        icondiv.classList.add("w-icon");
        icondiv.classList.add("w-icon-grey");
      } else {
        this.disableWeatherIcon = false;
        this.showTable = !this.showTable;
      }
    } catch (error) {
      console.error(error);
    }
  }
  getWeatherInformation() {
    try {
      if (this.scheduled && this.webMercatorUtils) {
        let geom: any;
        let lat: any;
        let lng: any;

        if (this.asset && this.asset[3].geometry) {
          geom = this.webMercatorUtils.webMercatorToGeographic(this.asset[3].geometry);
        } else if (this.geometry) {
          geom = this.webMercatorUtils.webMercatorToGeographic(this.geometry);
        } else {
          geom = JSON.parse(this.taskAttributes.GeomWKT);
        }
        if (geom.type === "point") {
          lat = geom.y;
          lng = geom.x;
        } else if (geom.type === "polyline") {
          lng = geom.paths[0][0][0];
          lat = geom.paths[0][0][1];
        }
        this.weatherService.getWeatherForcastfordate(this.scheduled, lat, lng).then(
          function (result) {
            if (result && result.dayForecast && result.dayForecast.length > 0) {
              this.setWeatherInfo(result);
            } else {
              const icondiv = document.getElementById("weatherIconDiv");
              icondiv.setAttribute("class", "");
              icondiv.classList.add("w-icon");
              icondiv.classList.add("w-icon-grey");
            }
          }.bind(this)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }
  setWeatherInfo(forecastData) {
    try {
      this.detailForecastData = forecastData.dayForecast;
      if (forecastData.timeForecast) {
        const icondiv = document.getElementById("weatherIconDiv");
        icondiv.setAttribute("class", "");
        icondiv.classList.add("w-icon");
        icondiv.classList.add(
          this.getRecommendationColorClassForIcon(forecastData.timeForecast.tempcolor, forecastData.timeForecast.windcolor, forecastData.timeForecast.humiditycolor, forecastData.timeForecast.raincolor)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }
  getRecommendationColorClassForIcon(temp, wind, humidity, rain) {
    try {
      if (temp === 3 || wind === 3 || humidity === 3 || rain === 3) {
        return "w-icon-red";
      } else if (temp === 2 || wind === 2 || humidity === 2 || rain === 2) {
        return "w-icon-yellow";
      }
      return "w-icon-green";
    } catch (error) {
      console.error(error);
    }
  }
  getColorClass(recommendation) {
    try {
      switch (recommendation) {
        case 1:
          return "w-r-green";
        case 2:
          return "w-r-yellow";
        case 3:
          return "w-r-red";
      }
    } catch (error) {
      console.error(error);
    }
  }
  getRecommendationColorClass(temp, wind, humidity, rain) {
    if (temp === 3 || wind === 3 || humidity === 3 || rain === 3) {
      return "fa fa-times r-red";
    } else if (temp === 2 || wind === 2 || humidity === 2 || rain === 2) {
      return "fa fa-check r-yellow";
    }
    return "fa fa-check r-green";
  }

  getActivity(maintId:string) {
    try {
      this.getFilteredFeaturesByFieldSubscribe = this.genericLayerService.getFilteredFeaturesByField(this.currentUser.tableIds.activityId, "MaintID", maintId).subscribe((results: any) => {
        this.activity = results.features[0].attributes.Activity;
      });
    } catch (error) {
      console.error(error);
    }
  }

  public activityChange(activity: string) {
    try {
      // get expected duration
      this.getFilteredFeaturesByTwoFieldSubscribe = this.genericLayerService
        .getFilteredFeaturesByTwoField(this.currentUser.tableIds.activityDurationId, "ActivityCode", activity, "AssetClass", this.layerName)
        .subscribe( (res: any) => {
          if (res.features.length > 0) {
            const totalMinutes = res.features[0].attributes.RequiredTime;
            this.duration = totalMinutes;
            this.dminutes = this.duration % 60;
            this.dhours = (this.duration - this.dminutes) / 60;
          } else {
            this.duration = 60;
            this.dminutes = this.duration % 60;
            this.dhours = (this.duration - this.dminutes) / 60;
          }
          this.checkUserLoad(this.scheduled);
        }
      );
      // get required supplies
      this.getFilteredFeaturesByTwoFieldSubscribe = this.genericLayerService
        .getFilteredFeaturesByTwoField( this.currentUser.tableIds.activityToolkitId, 
                                        "Activity", activity, 
                                        "AssetClass", this.activitySubtypeId.toString() )  //10/15/26 is ActivityToolkit table's AssetClass field designed for activity subtypeId or asset LayerID????  or possibly ActivityToolkit subtype??  unused feature in any case.
        .subscribe((res: any) => {
          this.activityToolKitList = res.features;
        });
    } catch (error) {
      console.error(error);
    }
  }
  saveWorkOrderDefaults() {
    try {
      // let workOrderDefaults;
      const workOrderDefaults = { WorkOrder: this.defWorkOrder, Worker: this.defWorker, Reason: this.defReason, Comments: this.defComments, Description: this.defDesc };
      localStorage.setItem("workOrderDefaults", JSON.stringify(workOrderDefaults));
      this.workorderID = this.defWorkOrder;
      this.worker = this.defWorker;
      this.reason = this.defReason;
      this.comments = this.defComments;
      this.desc = this.defDesc;
      this.modalService.dismissAll();
    } catch (error) {
      console.error(error);
    }
  }
  clearDef() {
    this.defComments = "";
    this.defDesc = "";
    this.defReason = "";
    this.defWorker = "";
    this.defWorkOrder = "";
  }
  dateTimeChanged() {
    try {
      if (new Date(this.scheduled).getHours() >= 18) {
        const today = new Date();
        if (this.scheduled.getDate() === today.getDate() && this.scheduled.getMonth() === today.getMonth() && this.scheduled.getFullYear() === today.getFullYear()) {
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(7, 0, 0);

          this.scheduled = tomorrow;
        } else {
          const dtime = new Date(this.scheduled.setHours(7, 0, 0));
          this.scheduled = dtime;
        }
      }
      if (new Date(this.scheduled).getHours() < 7) {
        const dtime = new Date(this.scheduled.setHours(7, 0, 0));
        this.scheduled = dtime;
      }
      if (this.scheduled && this.worker) {
        this.checkUserLoad(this.scheduled);
      }
      if (new Date(new Date(this.scheduled).getTime() + parseInt(this.duration, 10) * 60000).getHours() >= 18) {
        this.scheduled = new Date(new Date(this.scheduled).getTime() - parseInt(this.duration, 10) * 60000);
      }
      this.getWeatherInformation();
    } catch (error) {
      console.error(error);
    }
  }
  workerChanged(event) {
    this.worker = event;
    if (this.scheduled) {
      this.checkUserLoad(this.scheduled);
    }
  }
  checkUserLoad(date: Date) {
    try {
      if (!date){
        return;
      }
      const SheduledDate = date.toLocaleDateString();
      const tomorrow = new Date(date);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const SheduledNextDate = tomorrow.toLocaleDateString();
      this.disabledSave = true;
      const strCond = "SheduledDate >'" + SheduledDate + "' and SheduledDate <'" + SheduledNextDate + "'  and Worker";
      //this.getFilteredFeaturesByFieldSubscribe = 
      this.genericLayerService.getFilteredFeaturesByField(this.currentUser.tableIds.maintenanceId, strCond, this.worker)
        .subscribe( (results: any) => {
          this.disabledSave = false;
          let totalDuration = 0;
          results.features.forEach((element:any) => {
            totalDuration += element.attributes.EstimatedDuration;
          });
          if (this.taskAttributes && this.taskAttributes.OBJECTID) {
            if (this.taskAttributes.Worker !== this.worker) {
              totalDuration += this.duration;
            } else {
              totalDuration += 0;
            }
          } else {
            totalDuration += this.duration;
          }
          if (totalDuration > 480) {
            Swal.fire("Selected User is Over Loaded! Please Select Another User");
            this.worker = "";
          }
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  openMaintenanceForm(content) {   //TDOD*** rename to openMaintDefaultsForm
    this.modalService.open(content, { windowClass: "modal-md-task" });
  }
  reasonChanged(event) {
    this.reason = event;
  }

  managedWorkerChanged(event) {
    this.defWorker = event;
  }
  managedReasonChanged(event) {
    this.defReason = event;
  }
  cancel() {
    this.modalService.dismissAll();
  }

  showUpperTools = false;
  toggleButtonValue = "vvv";
  toggleUpperTools() {
    this.showUpperTools = !this.showUpperTools;
    this.toggleButtonValue = this.showUpperTools ? '^^^' : 'vvv';
  }


}
